// extracted by mini-css-extract-plugin
module.exports = {"mainMenu":"WideHeader_mainMenu__1tWXM","active":"WideHeader_active__2ni-m"};